import {
  AuthenticationError,
  CustomAxiosRequestConfig,
  ShieldAxiosClient,
  ACCESS_TOKEN_STORAGE_KEY,
  REFRESH_TOKEN_STORAGE_KEY,
} from './ShieldAxiosClient.ts';


export interface CustomFetchOptions {
  delay?: number;
  method: string;
  body?: any;

  /* If true, then failure to auth won't result in application reload. */
  skipReloadOnAuthError?: boolean

  /* If true, then request will be made without authentication headers attached (and required). */
  skipAuth?: boolean;

  withCredentials?: boolean;
};

export interface CustomFetchResponse<T = any> {
  data: T;
  status: number;
  ok: boolean;
}

export const customFetchV2 = async<T>(url: string, options: CustomFetchOptions): Promise<CustomFetchResponse<T>> => {
  const { delay, method, body, withCredentials } = options;

  if (delay) {
    await new Promise(resolve => setTimeout(resolve, delay));
  }

  const axiosConfig: CustomAxiosRequestConfig = {
    url,
    method,
    data: body,

    /* TODO: 22Apr24: Remove this soon.. Always send credentials in requests...*/
    withCredentials: withCredentials ?? true,   /* Defaults to true if withCredentials is null or undefined. */
    skipAuth: options.skipAuth || false,
  };

  try {
    const response = await ShieldAxiosClient.request<T>(axiosConfig);

    return {
      data: response.data,
      status: response.status,
      ok: response.status >= 200 && response.status < 300,
    };
  } catch (error) {
    if (error instanceof AuthenticationError) {
      // Tokens are invalid (and can't be refreshed)
      window.localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
      window.localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);

      if (!options.skipReloadOnAuthError) {
        // Small sleep before reloading the page... allows anything to finish (e.g Sentry error handlers)
        await new Promise(resolve => setTimeout(resolve, 1000));
        window.location.href = '/dashboard';
      }
    }

    throw error;
  }
};
